export default __webpack_public_path__ + "static/media/Electronics.5252fd66.png";